$(function(){
    // observer for footer height
    const footer = document.querySelector('.footer');

    const setFooterHeight = (height = 0) => {
        document.querySelector('.footer-parallax-offset').style.setProperty('margin-bottom', height + "px");
    }
    
    let prevHeight = 0;
    
    const resizeObserver = new ResizeObserver(entries => {
        for ( const entry of entries ) {

            const height = entry.borderBoxSize?.[0].blockSize;

            if ( typeof height === 'number' && height !== prevHeight ) {
                prevHeight = height;
                setFooterHeight( height );
            }

        }
    });

    resizeObserver.observe( footer );
});
